<template>
  <div class="tag-input">
    <Popover placement="right">
      <Button class="button--small" :disabled="!tags.length || disabled">{{ label }}</Button>
      <div slot="popover" class="selects">
        <CheckBox v-for="tag in deletedTags" :key="tag.id" class="item deleted" :value="tag" v-model="updatedValue">
          <TagIcon v-if="tag.icon" :id="tag.icon" />{{ tag.name }}
        </CheckBox>
        <CheckBox v-for="tag in tags" :key="tag.id" class="item" :value="tag" v-model="updatedValue">
          <TagIcon v-if="tag.icon" :id="tag.icon" />{{ tag.name }}
        </CheckBox>
      </div>
    </Popover>
    <div v-if="value.length > 0" class="clear-all" @click="updatedValue = []">
      <ClearIcon /><span>すべてクリア</span>
    </div>
    <TagLabels v-if="value.length" class="labels" :tags="value" />
  </div>
</template>

<script>
import Button from '@/components/atoms/Button'
import CheckBox from '@/components/atoms/CheckBox'
import Popover from '@/components/molecules/Popover'
import TagIcon from '@/components/icons/TagIcon'
import TagLabels from '@/components/molecules/TagLabels'
import ClearIcon from '@/components/icons/clear'

export default {
  name: 'TagInput',
  components: {
    Button,
    CheckBox,
    Popover,
    TagIcon,
    TagLabels,
    ClearIcon,
  },
  model: {
    prop: 'value',
    event: 'update',
  },
  props: {
    value: Array,
    tags: Array,
    label: String,
    disabled: Boolean,
  },
  data() {
    return {
      origin: this.value,
    }
  },
  computed: {
    deletedTags() {
      return this.origin.filter(({ id }) => !this.tags.find(tag => tag.id === id))
    },
    updatedValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
}
</script>

<style lang="postcss" scoped>
.tag-input {
  display: grid;
  grid-gap: 8px 16px;
  grid-template-columns: auto auto 1fr;
}

.button--small:focus {
  box-shadow: none;
}

.clear-all {
  align-items: center;
  cursor: pointer;
  display: flex;

  svg {
    fill: var(--very-dark-gray-2);
    height: 24px;
    opacity: 0.6;
    width: 24px;
  }

  span {
    color: var(--moderate-blue);
    font-size: 15px;
    line-height: 1;
  }
}

.selects {
  background-color: var(--white);
  box-sizing: border-box;
  fill: var(--very-dark-gray);
  max-height: 325px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  padding: 0 16px;
  width: 330px;
}

.item {
  border-bottom: 1px solid var(--border-color);
  cursor: pointer;
  padding: 8px 0;
  width: 100%;

  &:last-child {
    border-bottom: 0;
  }
}

.deleted {
  text-decoration: line-through;
}

.labels {
  grid-column: 1 / -1;
}
</style>
